import React from 'react';
import { useTranslation } from 'react-i18next';
import './UnsupportedClientMessage.css';

interface UnsupportedClientMessageProps {
  clientId: string | null;
  error?: string | null;
}

/**
 * Component to display when a client_id is invalid or not supported
 */
export const UnsupportedClientMessage: React.FC<UnsupportedClientMessageProps> = ({ 
  clientId, 
  error
}) => {
  const { t } = useTranslation();

  const getErrorMessage = (): string => {
    if (error) {
      return t(error);
    }

    if (!clientId || clientId.trim() === '') {
      return t('unsupportedClient.errors.clientIdRequired');
    }

    return t('unsupportedClient.errors.notSupported', { clientId });
  };

  const getHelpText = (): string => {
    if (!clientId || clientId.trim() === '') {
      return t('unsupportedClient.help.clientIdRequired');
    }

    return t('unsupportedClient.help.notSupported');
  };

  return (
    <div className="unsupported-client">
      <div className="unsupported-client__container">
        <div className="unsupported-client__icon" aria-hidden="true">
          ⚠️
        </div>
        
        <h1 className="unsupported-client__title">
          {t('unsupportedClient.heading')}
        </h1>
        
        <div className="unsupported-client__message" role="alert" aria-live="polite">
          <p className="unsupported-client__error">
            {getErrorMessage()}
          </p>
          
          <p className="unsupported-client__help">
            {getHelpText()}
          </p>
        </div>
        
        {clientId && clientId.trim() !== '' && (
          <div className="unsupported-client__details">
            <p className="unsupported-client__client-info">
              <strong>{t('unsupportedClient.clientIdLabel')}</strong> <code>{clientId}</code>
            </p>
          </div>
        )}
        
        <div className="unsupported-client__actions">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="unsupported-client__retry-button"
          >
            {t('unsupportedClient.retry')}
          </button>
        </div>
      </div>
    </div>
  );
};